import React, { forwardRef } from 'react';
import { StyledText } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
export const Text = forwardRef(({ tag = 'p', children, id, variant = { type: 'copy', order: '1', style: 'normal' }, className, 'data-testid': dataTestId, margin }, ref) => (React.createElement(StyledText, { id: id, as: tag, className: className, variant: variant, "data-testid": dataTestId, ref: ref, margin: margin }, children)));
Text.displayName = 'Text';
//# sourceMappingURL=index.js.map